module.exports = __webpack_public_path__ + "img/burger-cheese.33413487.svg";